var map = {
	"./calender.png": "./src/styles/icons/sidemenu/calender.png",
	"./completed-jobs-reverse.png": "./src/styles/icons/sidemenu/completed-jobs-reverse.png",
	"./completed-jobs.png": "./src/styles/icons/sidemenu/completed-jobs.png",
	"./contact-go-trashy.png": "./src/styles/icons/sidemenu/contact-go-trashy.png",
	"./draft-jobs.png": "./src/styles/icons/sidemenu/draft-jobs.png",
	"./list-icon.png": "./src/styles/icons/sidemenu/list-icon.png",
	"./logout.png": "./src/styles/icons/sidemenu/logout.png",
	"./my-bids.png": "./src/styles/icons/sidemenu/my-bids.png",
	"./my-job.png": "./src/styles/icons/sidemenu/my-job.png",
	"./my-jobs.png": "./src/styles/icons/sidemenu/my-jobs.png",
	"./new-jobs.png": "./src/styles/icons/sidemenu/new-jobs.png",
	"./preferences.png": "./src/styles/icons/sidemenu/preferences.png",
	"./q-mark.png": "./src/styles/icons/sidemenu/q-mark.png",
	"./quick-haul.png": "./src/styles/icons/sidemenu/quick-haul.png",
	"./tutorial.png": "./src/styles/icons/sidemenu/tutorial.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/styles/icons/sidemenu recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu ^\.\/.*$
// module id = ./src/styles/icons/sidemenu recursive ^\.\/.*$
// module chunks = 0